<template>
    <rkm-modal
        :buttons="['cancel', 'save']"
        :loading="loading"
        @save="handleSave"
        large
        ref="RkmModal"
        title="Anotações da enfermagem"
    >
        <Form
            :data="data"
            :model="model"
            @saved="saved"
            ref="Form"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Others.
import moment from 'moment'

export default {
    components: { Form },
    data: () => ({
        loading: false,
        model: {},
        repositories: {},
    }),
    methods: {
        open(item) {
            if (item) {
                this.model = {
                    id: item.id,
                    dataHoraAnotacao: item.dataHoraAnotacao,
                    anotacao: item.anotacao,
                    dataAnotacao: moment(item.dataHoraAnotacao, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD'),
                    horaAnotacao: moment(item.dataHoraAnotacao, 'DD/MM/YYYY HH:mm').format('HH-mm'),
                }
            } else {
                this.model = {
                    id: null,
                    dataHoraAnotacao: null,
                    anotacao: null,
                    dataAnotacao: moment(this.data.form.dataAtual, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                    horaAnotacao: null,
                }
            }

            this.$refs.RkmModal.show()
        },
        handleSave() {
            this.$refs.Form.save()
        },
        handleExit() {
            this.$refs.RkmModal.hide()
        },
        saved() {
            this.handleExit()
        },
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>